import { Canvas } from "@react-three/fiber";
import { OrbitControls, Text, Line } from "@react-three/drei";
import './CommonCanvas.scss'; // Import the CSS file for styling
import CustomToolTip from './CustomToolTip'; // adjust path if needed
import { ReplaceModelDivider, ReplaceModelSvg } from "./svgs/Svgs";

export default function CommonCanvas({
    model,
    camera = { position: [-4, 4.5, 12], fov: 20 },
    controls = {},
    axisSize = 1.2,
    axisLineWidth = 0.5,
    textSize = 0.15,
    showAxes = true,
    setLightingInCanvas,
    onReplaceModel,
    modelName,
    disabled = false
}) {
    const labelOffset = axisSize + axisSize * 0.15;

    return (
        <div className='common-canvas-container'>
            {/* Replace Model Button */}
            {onReplaceModel && (
                <div className="canvas-replace-button">
                    <CustomToolTip title={modelName || ''} placement="top">
                        <span className='canvas-replace-button-span'>
                            {modelName || 'Model'}
                        </span>
                    </CustomToolTip>
                    <ReplaceModelDivider />
                    <CustomToolTip title="Replace Model" placement="top">
                        <span
                            className={`canvas-replace-button-svg${disabled ? ' disabled' : ''}`}
                            onClick={disabled ? undefined : onReplaceModel}
                            tabIndex={disabled ? -1 : 0}
                            aria-disabled={disabled}
                            style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1 }}
                        >
                            <ReplaceModelSvg />
                        </span>
                    </CustomToolTip>
                </div>
            )}
            <Canvas camera={camera} className="w-100 h-100">
                <OrbitControls {...controls} />
                {setLightingInCanvas?.()}

                {model && (
                    <>
                        {/* Model */}
                        <primitive
                            object={model}
                            position={[0, 0, 0]}
                            rotation={[-Math.PI / 2, Math.PI, Math.PI]}
                        />

                        {showAxes && (
                            <>
                                {/* Axes */}
                                <axesHelper args={[axisSize]} />

                                {/* Negative axis lines */}
                                <Line points={[[0, 0, 0], [-axisSize, 0, 0]]} color="#ff6666" lineWidth={axisLineWidth} />
                                <Line points={[[0, 0, 0], [0, -axisSize, 0]]} color="#66ff66" lineWidth={axisLineWidth} />
                                <Line points={[[0, 0, 0], [0, 0, -axisSize]]} color="#6666ff" lineWidth={axisLineWidth} />

                                {/* Axis labels */}
                                <Text
                                    position={[labelOffset, 0, 0]}
                                    fontSize={textSize}
                                    color="#ff0000"
                                    anchorX="center"
                                    anchorY="middle"
                                >
                                    X
                                </Text>
                                <Text
                                    position={[-labelOffset, 0, 0]}
                                    fontSize={textSize}
                                    color="#ff6666"
                                    anchorX="center"
                                    anchorY="middle"
                                >
                                    -X
                                </Text>

                                <Text
                                    position={[0, labelOffset, 0]}
                                    fontSize={textSize}
                                    color="#00ff00"
                                    anchorX="center"
                                    anchorY="middle"
                                >
                                    Y
                                </Text>
                                <Text
                                    position={[0, -labelOffset, 0]}
                                    fontSize={textSize}
                                    color="#66ff66"
                                    anchorX="center"
                                    anchorY="middle"
                                >
                                    -Y
                                </Text>

                                <Text
                                    position={[0, 0, labelOffset]}
                                    fontSize={textSize}
                                    color="#0000ff"
                                    anchorX="center"
                                    anchorY="middle"
                                >
                                    Z
                                </Text>
                                <Text
                                    position={[0, 0, -labelOffset]}
                                    fontSize={textSize}
                                    color="#0000ff"
                                    anchorX="center"
                                    anchorY="middle"
                                >
                                    -Z
                                </Text>
                            </>
                        )}
                    </>
                )}
            </Canvas>
        </div>
    );
}
